import { render, staticRenderFns } from "./FamilyApprovalTimeline.vue?vue&type=template&id=2bbeb21e&scoped=true&"
import script from "./FamilyApprovalTimeline.vue?vue&type=script&lang=js&"
export * from "./FamilyApprovalTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbeb21e",
  null
  
)

export default component.exports